import { upsertStyleTag, removeStyleTag } from "../../domStyles";

const ROOT = document.documentElement;
const CLASS = "incluway-line-spacing";
const STYLE_ID = "incluway-line-spacing-style";
const EXCLUDE = "#incluway-widget-root";

const DEFAULT_LINE_HEIGHT = 1.45;

function approx(a: number, b: number, eps = 0.001) {
  return Math.abs(a - b) < eps;
}

export function setLineSpacing(value: number) {
  if (!Number.isFinite(value) || approx(value, DEFAULT_LINE_HEIGHT)) {
    disableLineSpacing();
    return;
  }

  upsertStyleTag(
    STYLE_ID,
    `
html.${CLASS} :not(${EXCLUDE}):not(${EXCLUDE} *) {
  line-height: var(--incluway-line-height) !important;
}
`.trim(),
  );

  const clamped = Math.max(0.9, Math.min(3.0, value));
  ROOT.style.setProperty("--incluway-line-height", String(clamped));
  ROOT.classList.add(CLASS);
}

export function disableLineSpacing() {
  ROOT.classList.remove(CLASS);
  ROOT.style.removeProperty("--incluway-line-height");
  removeStyleTag(STYLE_ID);
}
